import { render, staticRenderFns } from "./questionBank_info_list_set_type_1.vue?vue&type=template&id=da35eb0a&scoped=true"
import script from "./questionBank_info_list_set_type_1.vue?vue&type=script&lang=js"
export * from "./questionBank_info_list_set_type_1.vue?vue&type=script&lang=js"
import style0 from "./questionBank_info_list_set_type_1.vue?vue&type=style&index=0&id=da35eb0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da35eb0a",
  null
  
)

export default component.exports